module.exports = __webpack_public_path__ + "static/media/evac-pod-offline.132c6ba4.svg";